<div
    class="driver-detail-container flex flex-column gap-4 justify-content-center align-items-center"
>
    <p-card
        class="w-full"
        [header]="'CUSTOMER_DETAILS' | translate"
        *ngIf="customer"
    >
        <p-tabView>
            <!-- Home Tab -->
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i class="pi pi-user mr-2"></i>
                    <span class="tab-title">{{
                        "CUSTOMER_DETAILS" | translate
                    }}</span>
                </ng-template>
                <div class="">
                    <div
                        class="border-300 pt-4 flex flex-column"
                        *ngIf="customer.customerType === 'INDIVIDUAL'"
                    >
                        <span class="font-small text-400 font-bold mb-4">{{
                            "INDIVIDUAL_DETAILS" | translate
                        }}</span>
                        <div
                            class="flex w-full flex-wrap"
                            *ngIf="customer.customerType === 'INDIVIDUAL'"
                        >
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.contactInfo.firstName
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "FIRST_NAME" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.contactInfo.surname
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "SURNAME" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    formatText(customer.customerType)
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "CUSTOMER_TYPE" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.individualInfo?.dateOfBirth
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "DATE_OF_BIRTH" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    formatText(customer.individualInfo?.gender)
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "GENDER" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    formatText(
                                        customer.individualInfo
                                            ?.identificationType
                                    )
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "IDENTIFICATION_TYPE" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.individualInfo?.idNumber
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "IDENTIFICATION_NUMBER" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.individualInfo?.countryOfIDIssue
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "COUNTRY_OF_ID_ISSUE" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.individualInfo?.nationality
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "Nationality" | translate
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="border-300 pt-4 flex flex-column"
                        *ngIf="customer.customerType === 'CORPORATE'"
                    >
                        <span class="font-small text-400 font-bold mb-4">{{
                            "CONTACT_DETAILS" | translate
                        }}</span>
                        <div
                            class="flex w-full flex-wrap"
                            *ngIf="customer.customerType === 'CORPORATE'"
                        >
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.corporateInfo?.companyName
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "COMPANY_NAME" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    formatText(customer.customerType)
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "CUSTOMER_TYPE" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900"
                                    >{{
                                        customer.corporateInfo
                                            ?.companyRegistrationNumber
                                    }}
                                </span>
                                <span class="text-500 text-sm">{{
                                    "COMPANY_REGISTRATION_NUMBER" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.corporateInfo?.dateOfIncorporation
                                        | date : "short"
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "DATE_OF_INCORPORATION" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.corporateInfo?.licenceNumber
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "COMPANY_LICENCE_NUMBER" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.corporateInfo?.taxNumber
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "TAX_NUMBER" | translate
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="border-300 pt-4 border-top-1 flex flex-column">
                        <span class="font-small text-400 font-bold mb-4">{{
                            "CONTACT_DETAILS" | translate
                        }}</span>
                        <div class="flex w-full flex-wrap">
                            <div
                                class="flex flex-column pb-4 w-30rem"
                                *ngIf="customer.customerType === 'CORPORATE'"
                            >
                                <span class="text-900">{{
                                    customer.contactInfo.firstName
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "CONTACT_PERSON_FIRST_NAME" | translate
                                }}</span>
                            </div>
                            <div
                                class="flex flex-column pb-4 w-30rem"
                                *ngIf="customer.customerType === 'CORPORATE'"
                            >
                                <span class="text-900">{{
                                    customer.contactInfo.surname
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "CONTACT_PERSON_LAST_NAME" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.contactInfo.contactEmail
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "CONTACT_EMAIL" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.contactInfo.contactMobileNumber
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "CONTACT_MOBILE_NUMBER" | translate
                                }}</span>
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900"
                                    >{{ customer.address.streetNumber }},
                                    {{ customer.address.suburb }},
                                    {{ customer.address.city }}</span
                                >
                                <span class="text-500 text-sm">{{
                                    "PHYSICAL_ADDRESS" | translate
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="border-300 border-top-1 pt-4 flex flex-column">
                        <span class="font-small text-400 font-bold mb-4">{{
                            "STATUS" | translate
                        }}</span>
                        <div class="flex w-full flex-wrap">
                            <div
                                class="flex flex-column pb-4 w-30rem"
                                *ngIf="customer.kycStatus"
                            >
                                <span class="text-900">{{
                                    formatText(customer.kycStatus)
                                }}</span>
                                <span class="text-500 text-sm"
                                    >Customer KYC Status</span
                                >
                            </div>
                            <div class="flex flex-column pb-4 w-30rem">
                                <span class="text-900">{{
                                    customer.status | translate
                                }}</span>
                                <span class="text-500 text-sm">{{
                                    "Customer Status" | translate
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full flex-1 mt-4 pt-4 border-top-1 border-300">
                    <h5>{{ "CUSTOMER_PROFILE_DOCUMENTS" | translate }}</h5>
                    <p-progressBar
                        *ngIf="loadingDocumentView"
                        mode="indeterminate"
                        [style]="{ height: '6px' }"
                    ></p-progressBar>
                    <p-table
                        *ngIf="
                            customerDocuments && customerDocuments.length > 0;
                            else noCustomerDocuments
                        "
                        [value]="customerDocuments"
                        class="w-full mt-2"
                        [rowsPerPageOptions]="[10, 15, 20]"
                        responsiveLayout="scroll"
                    >
                        <ng-template pTemplate="header">
                            <tr>
                                <th>
                                    {{ "DOCUMENT_NAME_COLUMN" | translate }}
                                </th>
                                <th>{{ "DOCUMENT_NUMBER" | translate }}</th>
                                <th>{{ "DATE_UPLOADED" | translate }}</th>
                                <th>{{ "EXPIRY_DATE" | translate }}</th>
                                <th>{{ "MIME_TYPE" | translate }}</th>
                                <th>{{ "DOCUMENT_STATUS" | translate }}</th>
                                <th>{{ "ACTIONS" | translate }}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-document>
                            <tr
                                [ngClass]="
                                    document.status === 'VERIFIED'
                                        ? 'clearBg'
                                        : 'orangeBg'
                                "
                            >
                                <td>
                                    <span class="p-column-title"
                                        >Document Name</span
                                    >
                                    {{ document.documentName | translate}}
                                </td>
                                <td>
                                    <span class="p-column-title"
                                        >Document Number</span
                                    >
                                    {{
                                        document.documentNumber
                                            ? document.documentNumber
                                            : "---"
                                    }}
                                </td>
                                <td>
                                    <span class="p-column-title"
                                        >Date Uploaded</span
                                    >
                                    {{
                                        document.uploadDate
                                            ? (document.uploadDate
                                              | date : "short")
                                            : "---"
                                    }}
                                </td>
                                <td>
                                    <span class="p-column-title"
                                        >Expiry Date</span
                                    >
                                    {{
                                        document.expiryDate
                                            ? (document.expiryDate
                                              | date : "short")
                                            : "---"
                                    }}
                                </td>
                                <td>
                                    <span class="p-column-title"
                                        >Mime Type</span
                                    >
                                    {{
                                        document.mimeType
                                            ? document.mimeType
                                            : "---"
                                    }}
                                </td>

                                <td>
                                    <span class="p-column-title"
                                        >Expiry Date</span
                                    >{{
                                        document.status
                                            ? (document.status | translate)
                                            : "---"
                                    }}
                                </td>
                                <td class="flex">
                                    <span class="p-column-title">Actions</span>
                                    <p-button
                                        *ngIf="document.status !== 'VERIFIED'"
                                        icon="pi pi-info-circle"
                                        (onClick)="getKycDocument(document.id)"
                                        severity="success"
                                        pTooltip="{{ 'VERIFY_DOCUMENT' | translate }}"
                                        [rounded]="true"
                                    />
                                    <div
                                        pTooltip="{{ 'DOCUMENT_VERIFIED_TOOLTIP' | translate }}"
                                        class="w-3rem"
                                    >
                                        <p-button
                                            
                                            *ngIf="
                                                document.status === 'VERIFIED'
                                            "
                                            icon="pi pi-info-circle"
                                            (onClick)="openVerifiedCustomerDocument(document.id,document.mimeType)"
                                            [outlined]="true"
                                            severity="success"
                                            [rounded]="true"
                                        />
                                    </div>
                                    
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <ng-template #noCustomerDocuments>
                        <div class="flex align-items-center gap-2 mt-4">
                            <i
                                class="pi pi-exclamation-triangle"
                                style="color: orangered"
                            ></i>
                            <span>{{'NO_UPLOADED_DOCUMENTS' | translate}}</span>
                        </div>
                    </ng-template>
                    <div class="mt-6">
                        <p-button
                            icon="pi pi-arrow-left"
                            severity="secondary"
                            [label]="'BACK_TO_CUSTOMERS' | translate"
                            (onClick)="closeClicked()"
                        ></p-button>
                    </div>
                </div>
            </p-tabPanel>

            <!-- Profile Tab with Badge -->
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i class="pi pi-car mr-2"></i>
                    <span class="tab-title">{{'Vehicles' | translate}}</span>
                </ng-template>
                <div class="tab-body">
                    <app-kyc-vehicles-list
                        [customerId]="customerId"
                        [vehicles]="vehicles"
                    ></app-kyc-vehicles-list>
                </div>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i class="pi pi-users mr-2"></i>
                    <span class="tab-title">{{'Drivers' | translate}}</span>
                </ng-template>
                <div class="tab-body">
                    <app-kyc-drivers-list
                        [customerId]="customerId"
                        [drivers]="drivers"
                    ></app-kyc-drivers-list>
                </div>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i class="pi pi-folder-open mr-2"></i>
                    <span class="tab-title">{{'Portfolio' | translate}}</span>
                </ng-template>
                <div class="tab-body">
                    <app-kyc-policies-list [customerId]="customerId">
                    </app-kyc-policies-list>
                </div>
            </p-tabPanel>
        </p-tabView>
    </p-card>
</div>
